<script>
import { mapActions } from 'vuex'

export default {
  props: {
    backend: {},
    title: { type: String, default: '' },
    modal: { type: Object, default: () => ({}) },
    mode: { type: String, default: 'tab' }
  },
  computed: {
    config () {
      const obj = {
        tela: null,
        acoes: {},
        columns: [],
        indices: []
      }

      // Define
      if (this.info.config && this.info.config.tela) obj.tela = this.info.config.tela
      if (this.info.config && this.info.config.acoes) obj.acoes = this.info.config.acoes
      if (this.info.list && this.info.list.columns) obj.columns = this.info.list.columns
      if (this.info.list && this.info.list.indices) obj.indices = this.info.list.indices

      // Retorno
      return obj
    }
  },
  async mounted () {
    this.info = await this.backend.info()
    await this.criaModal()
  },
  data () {
    return {
      info: {},
      modalAdd: false
    }
  },
  methods: {
    ...mapActions({
      newModal: 'modal/new',
      openModal: 'modal/open',
      confirmarModal: 'modal/confirmar',
      toaster: 'modal/toaster'
    }),
    async criaModal () {
      this.modalAdd = await this.newModal({
        component: this.modal.component,
        width: this.modal.width,
        onSave: async (data) => {
          if (data[this.modal.field]) this.refresh(data[this.modal.field])
          else this.$refs.completeGrid.refreshList()
        },
        onCancel: () => {
          this.$refs.completeGrid.focoPesquisa()
        }
      })
    },
    refresh (data) {
      if (this.mode === 'tab') this.$refs.completeGrid.refreshList()
      else if (this.mode === 'modal') this.$refs.completeGrid.changeBusca(data)
    },
    async getList (filtros) {
      let data = await this.backend.list(filtros)
      return {
        data: data.data,
        totalCount: data.total
      }
    },
    async novo () {
      let data = this.info.form.default
      this.openModal({ modal: this.modalAdd, data })
    },
    async editar (row) {
      let data = await this.backend.get(row.data.id)
      this.openModal({ modal: this.modalAdd, data })
    },
    async excluir (row) {
      this.confirmarModal({
        msg: 'Deseja realmente excluir esse registro?',
        onConfirm: async () => {
          await this.backend.del(row.data.id)
          this.toaster({ message: 'Excluido com sucesso!', color: 'success' })
          this.$refs.completeGrid.refreshList()
        }
      })
    },
    async selecionar (selecionado) {
      if (selecionado.id) this.$emit('save', selecionado)
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" :title="title" @onClose="() => $emit('cancel')">
    <ui-complete-grid
      ref="completeGrid"
      :tela="config.tela"
      :columns="config.columns"
      :indices="config.indices"
      :selection="mode === 'modal'"
      :datasource="getList"
      :acoes="config.acoes"
      @onSelect="selecionar"
      @onCancel="$emit('cancel')"
      @onAdd="novo"
      @onEdit="editar"
      @onDelete="excluir" />
  </ui-layout-modal>
</template>
